import log from 'loglevel';
import getProductListByPLC from "../Action/GetProductList/getProductListByPLC";
import { showGreenTick, isEmpty, getDate } from '../util/util';

const handleCrossGradeProducts = async (plc, productDetails, currentVersion, dispatch, credentials) => {
  log.debug('./handler/handleCrossGradeProducts called with plc :', plc);
  try {
    const prodListPreviouesVersionEligible = await getProductListByPLC(plc, credentials);
    log.debug('GetPreviousVersionProducts response : ', JSON.stringify(prodListPreviouesVersionEligible, 0, 2));

    let productVersions = [];
    const crossGradeProduct = [];
    // eslint-disable-next-line no-unused-vars
    let productVersionKeys;
    let crossGrade;
    productDetails.forEach(product => {
      // remove 'Autodesk' from DB old data.
      let { productLineName } = product;
      productLineName = productLineName.replace('Autodesk ', '');   
      
      const { release, contractEndDate} = product;
      productVersions.push(`${productLineName} ${release}`)
      const endDate = !isEmpty(contractEndDate) && getDate(contractEndDate)
      if(productLineName) {
        productVersionKeys = {
          [productLineName]: {
            [release]: product.productKey,
          },
          hasContractEndDate: endDate,
        }
      }
    })

    const suggestedCrosGradeProduct = [];
    // if previoues product list of versions are not an empty
    if(prodListPreviouesVersionEligible.data[0] !== null && prodListPreviouesVersionEligible.data.product[0] !== null){
      const { product:crossGradeProd } = prodListPreviouesVersionEligible.data; 
      crossGrade = crossGradeProd.filter((prd, i, element) => {
        const nextElement = element[i+1];
        if(prd.version === nextElement?.version 
          && prd.priorVersion === nextElement?.priorVersion 
          && prd.productName !== nextElement?.productName){
            return false;
        } 
        return true;
      })
      log.debug('Clean response from Previoues version(Array) ',crossGrade);
      crossGrade.forEach(product => {
        if(Number(currentVersion) - Number(product.priorVersion) < 4 
          && Number(product.priorVersion < Number(currentVersion))){
          let { productName } = product;
          const { priorVersion, productKey } = product; 
          productName = productName.replace('Autodesk ', ''); 
          crossGradeProduct.push(`${productName} ${priorVersion}`)
          if(productVersionKeys[productName]) {
            productVersionKeys[productName][priorVersion] = productKey
          } else {
            productVersionKeys[productName] = {}
            productVersionKeys[productName][priorVersion] = productKey
            suggestedCrosGradeProduct.push(productName)
          }
        }
      });
      log.debug('crossGradeProduct :- ', crossGradeProduct, productVersionKeys);
      // join two arrays.
      productVersions = [...productVersions, ...crossGradeProduct];
    }
    
    productVersions = productVersions.sort();
    productVersions = productVersions.sort((a, b) => {
      if(Number(a.slice(-4)) > Number(b.slice(-4))){
        return -1;
      }
      return 1;
    })
    productVersions = [...new Set(productVersions)];
    productVersions = productVersions.filter(a => Number(a.slice(-4)) >= 2017);
    
    productVersions = productVersions.filter(a => Number(a.slice(-4)) >= 2017);                    
    showGreenTick(dispatch);
    log.debug('dispatch (ENTER_REQUESTING_PRODUCT) with payload : ', JSON.stringify({
      selectedProduct: null,
      showVersionDropdown: true,
      productVersionKeys,
      productVersions,
      crossGradeProducts: [],
      suggestedCrosGradeProduct,
    }, 0, 2));

    return dispatch({
      type: 'ENTER_REQUESTING_PRODUCT',
      payload: {
        selectedProduct: null,
        showVersionDropdown: true,
        productVersionKeys,
        productVersions,
        crossGradeProducts: [],
        suggestedCrosGradeProduct,
      },
    }); 
  } catch (err) {
    log.error('Error ', err);
    return err;
  }
};

export default handleCrossGradeProducts;